import { theme } from "@tm/utility/global";
import React from "react";
import { H5TagStyle } from "./TextStyles.style";
import { usePartnerContext } from "@tm/static/partnerContext";
type Colors = typeof theme;
type ColorKey = keyof Colors;
interface H5TagProps {
  color?: Colors[ColorKey];
  children?: React.ReactNode;
  margin?: string;
}

const H5Tag: React.FC<H5TagProps> = ({ children, margin, color }) => {
  const context = usePartnerContext();
  return (
    <H5TagStyle
      context={context ? context : undefined}
      txtcolor={color}
      margin={margin}
    >
      {children}
    </H5TagStyle>
  );
};

export default H5Tag;
